export const translations = {
  rw: {
    // Header & Security
    secureBadge: '100% Umutekano',
    verifiedBy: 'Byemejwe na PawaPay',
    instantUnlock: 'Telefoni Ifungurwa Ako Kanya',

    // Initial lookup & Not-Found states
    searchTitle: 'Ishyura Telefoni Yawe',
    searchDesc: 'Shyiramo nimero ya kontaro cyangwa nomero ya telefoni (Device ID) urebe ibirarane.',
    searchPlaceholder: 'Urugero: A10000001 cyangwa ABC12345',
    searchBtn: 'Shakisha Kontaro',
    fetchingDetails: 'Turimo gushaka amakuru y\'iyi kontaro...',
    notFoundTitle: 'Telefoni Ntiyanditswe cyangwa Ntirakorerwa Emeza',
    notFoundDesc: 'Nomero y\'igikoresho {tag} ntiyabonetse cyangwa kontaro yacyo ntiyari yakemezwa muri sisitemu.',
    notFoundShopTip: 'Niba iyi ari telefoni nshya yo mu iduka, banza urangize kwinjiza umukiriya mbere yo kwakira ubwishyu.',
    notFoundCheckTag: 'Nyamuneka reba niba wanditse neza kode cyangwa nimero ya kontaro:',
    tryAnotherTagBtn: 'Shakisha Indi Kontaro',
    lookupFailedTitle: 'Kushakisha Kontaro Byanze',
    lookupFailedDesc: 'Ntabwo byashobotse kubona amakuru ya kontaro. Nyamuneka ongera urebe nimero wanditse.',

    // Status badges
    statusLocked: 'YAFUNZWE',
    statusActive: 'IRAKORA',
    contractLabel: 'Kontaro #',
    copiedToast: 'Nimero ya kontaro yakoporowe',
    payTab: 'Kwishyura',
    balanceTab: 'Umwenda Wanjye',
    recentPayments: 'Kwishyura bya Vuba',
    noPayments: 'Nta kwishyura kwabonetse',

    // Hero Balance
    remainingDebt: 'Umwenda Usigaye',
    paidLabel: 'Wishyuye:',
    ofTotal: 'kuri',

    // Amount Selection
    selectAmountTitle: 'Hitamo Amafaranga Wishyura',
    upfrontDeposit: 'Avansi yo Gutangira',
    upfrontNotice: 'Iyi telefoni nshya isaba kwishyura Avansi (Upfront Payment) kugira ngo ifungurwe iminsi 30 ya mbere.',
    dailyMin: 'Umunsi (Min)',
    oneWeek: 'Icyumweru',
    monthly: 'Ukwezi 1',
    payFull: 'Yose',
    overdueAlert: (n) => `Ufite ibirarane by'amezi ${n}. Ishyura kugira ngo wirinde ibindi bihano.`,
    catchUp: (n) => `🔴 Kwishyura Ibirarane (Amezi ${n})`,
    customAmountLabel: 'Andika Ayo Ushaka ',
    customTag: 'AYO USHAKA',
    customPlaceholder: 'Andika amafaranga',

    // Schedule / Balance Tab
    bstatTotalPaid: 'Wishyuye Yose ',
    bstatInstalmentsDone: 'Amezi Wishyuye',
    bstatRemaining: 'Umwenda Usigaye ',
    scheduleTitle: 'Gahunda yo Kwishyura',
    depositLabel: 'AVANSI',
    instalmentLabel: (n) => `UKWEZI KWA #${n}`,
    dueLabel: 'Tariki',
    expectedLabel: 'Iteganijwe',
    receivedLabel: 'Yakiriwe',
    surplusLabel: 'Ibisagutse',
    shortfallLabel: 'Ibibura',
    balanceLabel: 'Ibisigaye',
    statusPaid: 'YISHYUWE',
    statusOverdue: 'IKIRARANE',
    statusUpcoming: 'ITEGANIJWE',

    // Phone Input
    phoneLabel: 'Nimero ya Mobile Money',
    phoneSub: 'MTN cyangwa Airtel',
    phonePlaceholder: '078XXXXXXX cyangwa 072XXXXXXX',

    // Action button
    payBtn: 'Ishyura',
    withCarrier: 'na',

    // Fully Paid State
    fullyPaidTitle: 'Kontaro Yarishyuwe',
    fullyPaidDesc: 'Urakoze! Warangije kwishyura iyi kontaro yose.',

    // Errors & Validation
    errorInvalidAmount: 'Nyamuneka shyiramo amafaranga yemewe.',
    errorMinDeposit: 'Kugira ngo telefoni ifungurwe, ugomba kwishyura byibura Avansi ya ',
    errorExceedsDebt: 'Amafaranga ntagomba kurenga umwenda usigaye wa',
    errorInvalidPhone: 'Nyamuneka shyiramo nimero nyayo yo mu Rwanda (urugero: 078XXXXXXX cyangwa 072XXXXXXX)',
    errorPromptFailed: 'Kwishyura Byanze',

    // PIN Waiting Screen
    authorizingTitle: 'Kwemereza Kuri Telefoni',
    authorizingSubtitle: 'Ubutumwa bwo kwishyura {amount} bwoherejwe kuri {phone}.',
    step1: 'Fungura telefoni yawe urebe ubutumwa bwa PIN.',
    step2: 'Shyiramo umubare w\'ibanga (PIN) wawe wemeze.',
    step3: 'Ntuve kuri iyi paji, igikorwa kirangira ako kanya.',
    cancelWaitingBtn: 'Guhagarika / Guhindura',

    // Success Screen
    successTitle: 'Kwishyura Byagenze Neza!',
    successSubtitle: 'Amafaranga yakiriwe neza. Telefoni yawe irafungurwa ako kanya.',
    receiptRef: 'Nimero y\'Ubwishyu',
    receiptTrId: 'Kode y\'Igikorwa',
    receiptChannel: 'Uburyo bwo Kwishyura',
    receiptStatus: 'Imiterere',
    receiptCompleted: 'BYARANGIYE',
    backToContractBtn: 'Subira Kuri Kontaro',

    // Error Screen
    failedTitle: 'Kwishyura Ntibyashobotse',
    failedSubtitle: 'Igikorwa cyahagaze, hashize igihe kirekire, cyangwa amafaranga ntahagije kuri Mobile Money.',
    errorTip1: '• Reba niba ufite amafaranga ahagije kuri Mobile Money.',
    errorTip2: '• Reba niba wanditse neza nimero ya telefoni.',
    errorTip3: '• Shyiramo PIN yawe mbere y\'amasegonda 60.',
    tryAgainBtn: 'Ongera Ugerageze',
  },

  en: {
    // Header & Security
    secureBadge: '100% Secure',
    verifiedBy: 'Verified by PawaPay',
    instantUnlock: 'Instant Phone Unlock',

    // Initial lookup & Not-Found states
    searchTitle: 'Pay For Your Phone',
    searchDesc: 'Enter your Contract Number or Device ID to view outstanding balance.',
    searchPlaceholder: 'e.g. A10000001 or ABC12345',
    searchBtn: 'Find Contract',
    fetchingDetails: 'Fetching live contract details...',
    notFoundTitle: 'Device Not Registered or Activated',
    notFoundDesc: 'Device ID {tag} was not found or its financing contract is not yet activated in the system.',
    notFoundShopTip: 'If this is a brand new phone at the shop, please complete client onboarding before processing payments.',
    notFoundCheckTag: 'Please check if the code or contract number is entered correctly:',
    tryAnotherTagBtn: 'Search Another Contract',
    lookupFailedTitle: 'Contract Lookup Failed',
    lookupFailedDesc: 'Could not retrieve contract details. Please check the reference.',

    // Status badges
    statusLocked: 'LOCKED',
    statusActive: 'ACTIVE',
    contractLabel: 'Contract #',
    copiedToast: 'Contract number copied to clipboard',
    payTab: 'Pay Now',
    balanceTab: 'My Balance',
    recentPayments: 'Recent Payments',
    noPayments: 'No payments found',

    // Hero Balance
    remainingDebt: 'Remaining Balance',
    paidLabel: 'Paid:',
    ofTotal: 'of',

    // Amount Selection
    selectAmountTitle: 'Select Payment Amount',
    upfrontDeposit: 'Upfront Deposit',
    upfrontNotice: 'This new contract requires the initial upfront deposit to activate and unlock for the first 30 days.',
    dailyMin: 'Daily Min',
    oneWeek: '1 Week',
    monthly: 'Monthly',
    payFull: 'Pay Full',
    overdueAlert: (n) => `You have ${n} overdue instalment${n > 1 ? 's' : ''}. Catch up to avoid further penalties.`,
    catchUp: (n) => `🔴 Catch Up (${n} month${n > 1 ? 's' : ''})`,
    customAmountLabel: 'Custom Amount ',
    customTag: 'CUSTOM',
    customPlaceholder: 'Enter amount',

    // Schedule / Balance Tab
    bstatTotalPaid: 'Total Paid ',
    bstatInstalmentsDone: 'Instalments Done',
    bstatRemaining: 'Remaining ',
    scheduleTitle: 'Payment Schedule',
    depositLabel: 'INITIAL DEPOSIT',
    instalmentLabel: (n) => `INSTALMENT #${n}`,
    dueLabel: 'Due',
    expectedLabel: 'Expected',
    receivedLabel: 'Received',
    surplusLabel: 'Surplus',
    shortfallLabel: 'Shortfall',
    balanceLabel: 'Balance',
    statusPaid: 'PAID',
    statusOverdue: 'OVERDUE',
    statusUpcoming: 'UPCOMING',

    // Phone Input
    phoneLabel: 'Mobile Money Number',
    phoneSub: 'MTN or Airtel',
    phonePlaceholder: '078XXXXXXX or 072XXXXXXX',

    // Action button
    payBtn: 'Pay',
    withCarrier: 'with',

    // Fully Paid State
    fullyPaidTitle: 'Contract Fully Paid',
    fullyPaidDesc: 'Congratulations! You have successfully completed all payments for this contract.',

    // Errors & Validation
    errorInvalidAmount: 'Please enter a valid payment amount.',
    errorMinDeposit: 'To activate this device, you must pay at least the upfront deposit of ',
    errorExceedsDebt: 'Amount cannot exceed the remaining debt of',
    errorInvalidPhone: 'Please enter a valid Rwanda phone number (e.g. 078XXXXXXX or 072XXXXXXX)',
    errorPromptFailed: 'Payment Request Failed',

    // PIN Waiting Screen
    authorizingTitle: 'Authorizing Payment',
    authorizingSubtitle: 'A Mobile Money prompt of {amount} was sent to {phone}.',
    step1: 'Unlock your phone and check for the PIN prompt.',
    step2: 'Enter your Mobile Money PIN to approve.',
    step3: 'Do not close this window; confirmation is instant.',
    cancelWaitingBtn: 'Cancel / Edit Details',

    // Success Screen
    successTitle: 'Payment Received!',
    successSubtitle: 'Your payment has been successfully confirmed and your device is being unlocked.',
    receiptRef: 'Reference',
    receiptTrId: 'Transaction ID',
    receiptChannel: 'Payment Channel',
    receiptStatus: 'Status',
    receiptCompleted: 'COMPLETED',
    backToContractBtn: 'Back to Contract',

    // Error Screen
    failedTitle: 'Payment Incomplete',
    failedSubtitle: 'The transaction was cancelled, timed out, or had insufficient funds on Mobile Money.',
    errorTip1: '• Ensure you have sufficient balance on your Mobile Money account.',
    errorTip2: '• Confirm your phone number is correct.',
    errorTip3: '• Enter your PIN within 60 seconds of the prompt.',
    tryAgainBtn: 'Try Again',
  },

  lg: {
    // Header & Security
    secureBadge: '100% Bukuumi',
    verifiedBy: 'Kikakasiddwa PawaPay',
    instantUnlock: 'Essimu Esumululwa Mangu',

    // Initial lookup & Not-Found states
    searchTitle: 'Sasulira Essimu Yo',
    searchDesc: 'Yingiza Ennamba ya Kontulakiti oba Ennamba y\'Essimu olabe ebbanja lyo.',
    searchPlaceholder: 'Okugeza: A10000001 oba ABC12345',
    searchBtn: 'Noonya Kontulakiti',
    fetchingDetails: 'Tukyakung\'aanya ebikwata ku kontulakiti...',
    notFoundTitle: 'Essimu Tonnaba Kuwandiisibwa oba Kukolebwaako',
    notFoundDesc: 'Ennamba y\'essimu {tag} tezuuliddwa oba kontulakiti yaayo tennakolebwaako mu sisitemu.',
    notFoundShopTip: 'Bwe buba nga buno bwe bukyali obupya ku dduuka, nsaba musooke mumalirize okusunsula omukozesa nga temunnaba kusasula.',
    notFoundCheckTag: 'Nsaba wekebejje oba ennamba oba koodi eyingiziddwa ntuufu:',
    tryAnotherTagBtn: 'Noonya Kontulakiti Endala',
    lookupFailedTitle: 'Okunoonya Kontulakiti Kugaanyi',
    lookupFailedDesc: 'Tekisobose kufuna bikwata ku kontulakiti. Nsaba wekebejje ennamba gy\'oyingizza.',

    // Status badges
    statusLocked: 'ESIBIDDWA',
    statusActive: 'EKOLA',
    contractLabel: 'Kontulakiti #',
    copiedToast: 'Ennamba ya kontulakiti ekoppeddwa',
    payTab: 'Sasula Kati',
    balanceTab: 'Ebbanja Lyange',
    recentPayments: 'Ebisasuddwa Ebyakakolebwa',
    noPayments: 'Tewali bisasuddwa bizuuliddwa',

    // Hero Balance
    remainingDebt: 'Ebbanja Eryasigalawo',
    paidLabel: 'Ezasasulwa:',
    ofTotal: 'ku',

    // Amount Selection
    selectAmountTitle: 'Londa Omuwendo Gw\'osasula',
    upfrontDeposit: 'Ddipoziti Ey\'olubereberye',
    upfrontNotice: 'Kontulakiti eno empya yeetaaga ddipoziti ey\'olubereberye okusobola okugikolezaako n\'okusumulula essimu okumala ennaku 30 ezisooka.',
    dailyMin: 'Buli Lunaku (Kitono)',
    oneWeek: 'Ssabbiiti 1',
    monthly: 'Buli Mwezi',
    payFull: 'Sasula Yonna',
    overdueAlert: (n) => `Olina emyezi ${n} egitannasasulwa. Sasula kati weewale ebibonerezo ebirala.`,
    catchUp: (n) => `🔴 Sasula Ezabuzeemu (Emyezi ${n})`,
    customAmountLabel: 'Yingiza Omuwendo Gw\'oyagala ',
    customTag: 'GWE WEYINGIRIZE',
    customPlaceholder: 'Yingiza omuwendo',

    // Schedule / Balance Tab
    bstatTotalPaid: 'Ezasasulwa Zonna ',
    bstatInstalmentsDone: 'Emyezi Egisasuddwa',
    bstatRemaining: 'Ezisigaddeyo ',
    scheduleTitle: 'Enteekateeka y\'Okusasula',
    depositLabel: 'DDIPOZITI EY\'OLUBEREBERYE',
    instalmentLabel: (n) => `OMWEZI GWA #${n}`,
    dueLabel: 'Ennaku z\'omwezi',
    expectedLabel: 'Ezaali Zisuubirwa',
    receivedLabel: 'Ezaafuniddwa',
    surplusLabel: 'Ezaasukkiridde',
    shortfallLabel: 'Ezibuzeemu',
    balanceLabel: 'Ezisigaddewo',
    statusPaid: 'ZASASUDDWA',
    statusOverdue: 'ZIKYABANJA',
    statusUpcoming: 'ZIRINDIRIDDWA',

    // Phone Input
    phoneLabel: 'Ennamba ya Mobile Money',
    phoneSub: 'MTN oba Airtel',
    phonePlaceholder: '077XXXXXXX oba 070XXXXXXX',

    // Action button
    payBtn: 'Sasula',
    withCarrier: 'nga okozesa',

    // Fully Paid State
    fullyPaidTitle: 'Kontulakiti Eweddeyo Okusasulwa',
    fullyPaidDesc: 'Tukuyozaayoza! Omalirizza bulungi ebisale byonna ebya kontulakiti eno.',

    // Errors & Validation
    errorInvalidAmount: 'Nsaba oyingize omuwendo gw\'ensimbi omutuufu.',
    errorMinDeposit: 'Okusobola okusumulula essimu eno, olina okusasula waakiri ddipoziti ey\'olubereberye eya ',
    errorExceedsDebt: 'Omuwendo tegusaanidde kusinga bbanja erisigaddeyo erya',
    errorInvalidPhone: 'Nsaba oyingize ennamba y\'essimu eya Uganda entuufu (okugeza 077XXXXXXX oba 070XXXXXXX)',
    errorPromptFailed: 'Okusaba Okusasula Kugaanyi',

    // PIN Waiting Screen
    authorizingTitle: 'Tukyakakasa Okusasula',
    authorizingSubtitle: 'Obubaka bwa Mobile Money obwa {amount} buweerezeddwa ku {phone}.',
    step1: 'Sumulula essimu yo olabe obubaka obukusaba PIN.',
    step2: 'Yingiza PIN yo eya Mobile Money okukakasa.',
    step3: 'Tosalawo oba okuggalwo ddirisa lino; okukakasa kukolebwa amangu ago.',
    cancelWaitingBtn: 'Sazaamu / Kyusa Ebikwataho',

    // Success Screen
    successTitle: 'Ensimbi Zaakiddwa!',
    successSubtitle: 'Okusasula kwo kwakakasiddwa era n\'essimu yo eri mu kusumululwa.',
    receiptRef: 'Ennamba y\'Ekisasuddwa',
    receiptTrId: 'Koodi y\'Okusasula',
    receiptChannel: 'Ekkubo ly\'Okusasulirako',
    receiptStatus: 'Embeera',
    receiptCompleted: 'KIWEDDE',
    backToContractBtn: 'Ddayo ku Kontulakiti',

    // Error Screen
    failedTitle: 'Okusasula Tekusobose',
    failedSubtitle: 'Omulimu guyimiriziddwa, ekiseera kiweddeko, oba ensimbi teziriiko zimala ku Mobile Money.',
    errorTip1: '• Kakasa nti olina ensimbi ezimala ku akaawunti yo eya Mobile Money.',
    errorTip2: '• Kakasa nti ennamba y\'essimu gy\'oyingizza ntuufu.',
    errorTip3: '• Yingiza PIN yo mu bbanga lya sikonda 60 okuva obubaka lwe bujje.',
    tryAgainBtn: 'Ddamu Ogezeeko',
  }
};
